module.exports = __webpack_public_path__ + "fonts/Impact.3eb51b5f.ttf";